import React, {PropTypes} from 'react';
import Modal from '../../Modal';
import {inject, observer} from 'mobx-react';
import {observable, action, toJS} from 'mobx';
import {workOrder} from "../api";
import {sort} from '../helper';

@inject('ticketStore', 'workOrderStore')
@observer
export default class WorkOrderTicketAdd extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  slug = this.props.params.work_order_id ? `/station/${this.props.params.id}/maintenance/work_order/${this.props.params.work_order_id}/view` : `/monitoring/work_order/tabular/${this.props.params.id}/view`;

  @observable selectedTicket = [];

  componentWillMount() {
    const {ticketStore, workOrderStore} = this.props;
    ticketStore.items.length === 0 && ticketStore.fetchItems();
    this.selectedTicket = workOrderStore.workOrder.ticket ? workOrderStore.workOrder.ticket.map(item => +item.id) : [];
  }

  @action onAddTicket = e => this.selectedTicket.push(+e.target.value);
  @action onRemoveTicket = id => this.selectedTicket = this.selectedTicket.filter(item => +item !== +id);

  onSave = () => {
    const {notify, router} = this.context;
    workOrder.ticket.save(this.props.params.work_order_id ? this.props.params.work_order_id : this.props.params.id, toJS(this.selectedTicket)).then(res => {
      notify.success(res);
      router.push(this.slug)
    }).catch(notify.error)
  };

  render() {
    const {ticketStore, workOrderStore} = this.props;

    let unSelectedTicket = this.selectedTicket && ticketStore.items.filter(item => {
      if(this.selectedTicket.indexOf(+item.id) === -1) return item.id;
    });

    return (
      <Modal slug={this.slug} title='Add/Remove Ticket'>
        <div>
          <select value="0" onChange={this.onAddTicket} style={{width:'70%'}}>
            <option value="0">Add Ticket</option>
            {sort(unSelectedTicket).filter(ticket => workOrderStore.workOrder.station.map(i => +i.id).includes(+ticket.station_id)).map((item, index) => (
              <option key={index} value={item.id}>{item.summary}</option>
            ))}
          </select><br/><br/>
          <div className='DataTable'>
            <table>
              <thead>
              <tr>
                <th>Ticket Number</th>
                <th>{}</th>
              </tr>
              </thead>
              <tbody>
              {sort(this.selectedTicket).map((item, i) => {
                const ticket = ticketStore.findById(item);

                return <tr key={`work_order_ticket_${i}`} className="childRow" style={{height: '30px'}}>
                  <td>{ticket ? ticket.summary : item}</td>
                  <td className='crudActions'><a onClick={() => this.onRemoveTicket(item)}><i className='fa fa-remove'/></a></td>
                </tr>
              })}
              </tbody>
            </table>
            <div className="tableActions">
              <button className="button" onClick={this.onSave}>Save</button>
            </div>
          </div>
          <br/>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/WorkOrderTicketAdd.js